/**
 *  
 *
 * Description  管理配置 日志管理 功能使用统计
 * 2019-6-17
 * Bai.Zhiming
 */

'use strict';
angular.module("featureUsageStatisticsRouterModule", [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.
        state("manageconfig.logmanage.featureusagestatistics", {
            url: '/featureusagestatistics?tenantid',
            views: {
                'main@manageconfig.logmanage': {
                    templateUrl: './manageConfig/logManageMent/featureUsageStatistics/featureUsageStatistics_tpl.html',
                    controller: 'featureUsageStatisticsCtrl',
                },
                'footer@manageconfig.logmanage': {
                    templateUrl: './footer_tpl.html'
                }
            }
        }).state("manageconfig.logmanage.featureusagestatistics.event", {
            url: '/event?eventid?title?date',
            views: {
                'event@manageconfig.logmanage.featureusagestatistics': {
                    templateUrl: './manageConfig/logManageMent/featureUsageStatistics/event/event_tpl.html',
                    controller: 'featureUsageStatisticsEventCtrl',
                }
            }
        });
    }]);